export default "__VITE_ASSET__DS5YRn85__"